module.exports = __webpack_public_path__ + "assets/img/question2021-bg.a99f9c5c.png";